'use client'
import React from 'react';
import SharedExperiencesList from './components/sharedExperiencesList';
import { Flex } from '@chakra-ui/layout';
export default function SharedExperiencesPage() {
  return (
    <Flex
      w="100%"
      h="100%"
    >
      <SharedExperiencesList />
    </Flex>
  )
} 